import { render, staticRenderFns } from "./MainNavigator.vue?vue&type=template&id=7a6ae0a8&scoped=true"
import script from "./MainNavigator.vue?vue&type=script&lang=js"
export * from "./MainNavigator.vue?vue&type=script&lang=js"
import style0 from "./MainNavigator.vue?vue&type=style&index=0&id=7a6ae0a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6ae0a8",
  null
  
)

export default component.exports